<template>
  <v-btn
    size="size"
    :disabled="disabled"
    @click="handleClick()"
    :block="blockButton"
    :dense="true"
    :dark="true"
    :class="className"
    :style="bgColor"
    
  >
    <v-icon left v-if="iconBut">
      {{ iconBut }}
    </v-icon>
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: "BtnComp",
  data(){
    return {
      // ACÁ SE DEFUBEN LOS COLORES QUE MANEJAREMOS PARA EL USO DEL BTN
      data_color:{
        primary:"#0277bd", 
        error:"#db1c19",
        warning:"#ffbc00",
        success:"#388e3c"
      }
    }
  },
  props: {
    className:String,
    size: String,
    color: {
      type:[String],
      default:'primary'
    },
    blockButton: Boolean,
    disabled: Boolean,
    text: String,
    iconBut: String,
  },
  computed:{
    bgColor(){
      return `background-color:${this.data_color[this.color]}`
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.btn_block_style2 {
  font-family: "avenir black";
  letter-spacing: 0.42px;
  font-size: 14px;
  color: #fff !important;
}

.btn_block_style2:hover {
  font-family: "avenir black oblique";
  /* background-color: #002f6c !important; */
  background-color: #ffbc00 !important;
  color: #000 !important;
}
</style>
